import { useQuery, keepPreviousData } from '@tanstack/react-query';
import type { RequestParams } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import { APPLICATION_KEYS } from '../lib';
import { ApplicationApi } from '../api';
import type { ApplicationBase } from './types';

export const useApplicationList = (params?: RequestParams) => {
  return useQuery<ApiResponseList<ApplicationBase>>({
    queryKey: APPLICATION_KEYS.list(params),
    queryFn: () => ApplicationApi.getList(params),
    placeholderData: keepPreviousData,
  });
};
